export const BLOCKED_MODELS = ['fofr/video-to-frames'];

export enum ModelProviderIdentifier {
  Civitai = '/civitai.com',
  FalDomain = '/fal.ai',
  FalPrefix = 'fal-ai',
  Replicate = 'https://replicate.com/',
}
